module.exports = __webpack_public_path__ + "4e68357c19a6a0d4a4ea434e014b895a.MP3";